import { RootState } from '@/shared/types/state';

export const selectIsPublishModalOpen = (state: RootState) => state.collections.isPublishModalOpen;

export const selectIsDeleteDatasourceModalOpen = (state: RootState) =>
  state.collections.isDeleteDatasourceModalOpen;

export const selectDeleteDatasourceTargetId = (state: RootState) =>
  state.collections.deleteDatasourceTargetId;

export const selectIsDeleteCollectionModalOpen = (state: RootState) =>
  state.collections.isDeleteCollectionModalOpen;

export const selectIsDeleteDocumentModalOpen = (state: RootState) =>
  state.collections.isDeleteDocumentModalOpen;

export const selectDeleteDocumentTarget = (state: RootState) =>
  state.collections.deleteDocumentTarget;

export const selectIsDeleteDocumentsModalOpen = (state: RootState) =>
  state.collections.isDeleteDocumentsModalOpen;

export const selectSelectedDocumentsForDeletion = (state: RootState) =>
  state.collections.selectedDocumentsForDeletion;
